export type FilterOption = {
  valueType: FilterOptionValueType;
};

export enum FilterOptionValueType {
  EnumType
}
